import { cx } from '@/lib/cx';

import styles from './PointsMeter.module.css';

const STEPS = [1, 2, 3, 4, 5];

/**
 * Sponsor points, 0 to 5, as five segments and a number.
 *
 * The bars are `aria-hidden` and the "3/5" is not. The number *is* the value; the bars
 * are a way of comparing it down a column at a glance. There is no `role="meter"`
 * because the text already says it, and a meter role on every row of a hundred-row
 * table is a screen reader reading out five hundred numbers nobody asked for.
 *
 * The thresholds (green from 4, amber from 3, grey below) are carried over
 * from the prototype. They are its choice, not a stated business rule.
 */
export function PointsMeter({ value }: { value: number }) {
  const tone = value >= 4 ? 'high' : value >= 3 ? 'mid' : 'low';

  return (
    <span
      className={styles.meter}
      title={value === 0 ? 'Not rated' : `${value} of 5 sponsor points`}
    >
      <span className={styles.bars} aria-hidden="true">
        {STEPS.map((step) => (
          <span key={step} className={styles.bar}>
            <span
              className={cx(styles.fill, styles[tone])}
              style={{ blockSize: `${Math.max(0, Math.min(1, value - step + 1)) * 100}%` }}
            />
          </span>
        ))}
      </span>
      <span className={styles.count}>{value === 0 ? 'Not rated' : `${value}/5`}</span>
    </span>
  );
}
